import React from 'react'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Link } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'

import HeaderPrimary from 'components/header-primary/header-primary'
import HeaderMobilePrimary from 'components/header-primary/header-mobile-primary'
import Subscribe from 'components/subscribe/subscribe'
import Footer from 'components/footer/footer'

class TakeMeHomeLayout extends React.Component {
	renderContent = () => {
		const meta = {
			title: `Take Me Home - ${safeSiteData.site_name}`,
			description: safeSiteData.site_description,
			canonical: safeSiteData.site_url,
			meta: {
				'og:url': safeSiteData.site_url,
				'og:title': safeSiteData.site_name,
				'og:description': safeSiteData.site_description,
				'og:image': `${safeSiteData.images_url}take-me-home/take-me-home-banner-full-c.jpg`
			}
		}

		return (
			<div>
				<DocumentMeta { ...meta } />

				<div className="take-me-home-hero">
					<div className="-bg">
						<img src={ `${safeSiteData.images_url}take-me-home/season-2/take-me-home-banner-full-2024.jpg` } alt="" />
					</div>
				</div>

				<div className="wide-sections">
					<div className="wide-section">
						<div className="main-title">
							<p className="take-me-home-intro-text">
								Take Me Home is a show about how SAFE Inc uses an innovative foster care model to save homeless pets.
							</p>

							<p className="take-me-home-intro-text">
								You can help by <Link to="/foster">fostering</Link>, <Link to="/find-a-pet">adopting</Link>, <Link to="/donate">donating</Link> or <Link to="/volunteer">volunteering</Link> today.
							</p>

							<br />

							<p className="take-me-home-intro-text">
								Missed an episode of Season 2? Don’t worry you can catch up on 9Now:
							</p>

							<p className="take-me-home-intro-text">
								<a href="https://www.9now.com.au/take-me-home" className="button" target="_blank" rel="noopener">Watch on 9Now</a>
							</p>

							<br />

							<p className="take-me-home-intro-text">
								Need more info? Contact us at <a href="mailto:info@safe.org.au">info@safe.org.au</a>.
							</p>
						</div>
					</div>

					<div className="wide-section -features">
						<div className="-inner">
							<div className="-features-grid -features-grid-4">
								<div className="-feature">
									<Link className="-feature-inner" to="/foster">
										<div className="-image">
											<img src={ safeSiteData.images_url + 'take-me-home/season-2/foster.jpg' } alt="" />
										</div>

										<div className="-text">
											<h3>Foster</h3>
										</div>
									</Link>
								</div>

								<div className="-feature">
									<Link className="-feature-inner" to="/find-a-pet">
										<div className="-image">
											<img src={ safeSiteData.images_url + 'take-me-home/season-2/adopt.jpg' } alt="" />
										</div>

										<div className="-text">
											<h3>Adopt</h3>
										</div>
									</Link>
								</div>

								<div className="-feature">
									<Link className="-feature-inner" to="/donate">
										<div className="-image">
											<img src={ safeSiteData.images_url + 'take-me-home/season-2/donate.jpg' } alt="" />
										</div>

										<div className="-text">
											<h3>Donate</h3>
										</div>
									</Link>
								</div>

								<div className="-feature">
									<Link className="-feature-inner" to="/volunteer">
										<div className="-image">
											<img src={ safeSiteData.images_url + 'take-me-home/season-2/volunteer.jpg' } alt="" />
										</div>

										<div className="-text">
											<h3>Volunteer</h3>
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div>

					{/*<div className="wide-section take-me-home-video">
						<div className="-iframe">
							<iframe src="https://player.vimeo.com/video/703080282?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
						</div>
					</div>*/}

					<div className="wide-section-sponsors wide-section">
						<div className="-inner">
							<h3>Sponsors</h3>

							<div className="-sponsors">
								<div className="-sponsor -no-link">
									<img src={ `${safeSiteData.images_url}sponsors/Velocity.png` } alt="Velocity logo" />
								</div>

								<a className="-sponsor" href="https://www.karrathatoyota.com.au/" target="_blank" rel="noopener">
									<img src={ `${safeSiteData.images_url}sponsors/KarrathaToyota.png` } alt="Karratha Toyota logo" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className="page-take-me-home">
				<HeaderMobilePrimary />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

					<HeaderPrimary />

					{ this.renderContent() }
				</div>

				<Footer />
			</div>
		)
	}
}

export default TakeMeHomeLayout



// WEBPACK FOOTER //
// ./views/layouts/main/take-me-home-layout.jsx